/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Enum_Natural_Sciences_And_Mathematics29Inputs */

const en_cv_extract_form_enum_natural_sciences_and_mathematics29 = /** @type {(inputs: Cv_Extract_Form_Enum_Natural_Sciences_And_Mathematics29Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Natural Sciences and Mathematics`)
};

const de_cv_extract_form_enum_natural_sciences_and_mathematics29 = /** @type {(inputs: Cv_Extract_Form_Enum_Natural_Sciences_And_Mathematics29Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naturwissenschaften und Mathematik`)
};

/**
* | output |
* | --- |
* | "Natural Sciences and Mathematics" |
*
* @param {Cv_Extract_Form_Enum_Natural_Sciences_And_Mathematics29Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_enum_natural_sciences_and_mathematics29 = /** @type {((inputs?: Cv_Extract_Form_Enum_Natural_Sciences_And_Mathematics29Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Enum_Natural_Sciences_And_Mathematics29Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_enum_natural_sciences_and_mathematics29(inputs)
	return en_cv_extract_form_enum_natural_sciences_and_mathematics29(inputs)
});
export { cv_extract_form_enum_natural_sciences_and_mathematics29 as "cv_extract_form_enum_NATURAL_SCIENCES_AND_MATHEMATICS" }